exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.toDownload[data-v-d6fbf624] {\n  color: #cccccc;\n  cursor: not-allowed;\n}\n", "", {"version":3,"sources":["/data/node_workspace_2_15/workspace/uat-deploy-erp-frontproject/src/public/components/kye-edit-table/edit-form.vue"],"names":[],"mappings":";AACA;EACE,eAAe;EACf,oBAAoB;CACrB","file":"edit-form.vue","sourcesContent":["\n.toDownload[data-v-d6fbf624] {\n  color: #cccccc;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/cache-loader/dist/cjs.js!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d6fbf624","scoped":true,"hasInlineConfig":false}!./node_modules/fast-sass-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/public/components/kye-edit-table/edit-form.vue
// module id = 6OAP
// module chunks = 6